import {PlateSchema} from 'samples/storables/StorableSchemaConstants';
import * as net from 'util/Net';
import * as TaskRunner from 'util/TaskRunner';

import {CreatePlateSchemaParams} from './SampleSchemaActions';

interface CreatePlateSchemaWithRegistryId extends CreatePlateSchemaParams {
  registryId: string;
}

export function fetchAll(): JQueryPromise<{data: Array<PlateSchema>}> {
  return net.getJSON('/1/api/plate-schemas');
}

export function create(data: CreatePlateSchemaWithRegistryId): JQueryPromise<PlateSchema> {
  return net.postJSON({url: '/1/api/plate-schemas', data});
}

export function deletePlateSchema(plateSchemaId: string): JQueryPromise<{}> {
  return net.delete_({url: `/1/api/plate-schemas/${plateSchemaId}`});
}

export function update(plateSchemaId: string, data: CreatePlateSchemaParams): JQueryPromise<PlateSchema> {
  return TaskRunner.patchJSON({url: `/1/api/plate-schemas/${plateSchemaId}`, data});
}
